import type { FilterState } from './types'
import { DEFAULT_TENANT_ID as SHARED_DEFAULT_TENANT_ID } from 'shared/utils/tenantContext'

export const DEFAULT_TENANT_ID = SHARED_DEFAULT_TENANT_ID
export const PAGE_SIZE = 20
export const PERMIT_TYPE_OPTIONS = [
  { value: 'all', label: 'ทุกประเภท' },
  { value: 'Hot Work', label: 'Hot Work' },
  { value: 'Cold Work', label: 'Cold Work' },
  { value: 'Confine Work Space', label: 'Confine Work' },
]
export const todayInput = () => {
  const date = new Date()
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export const createDefaultFilters = (): FilterState => ({
  search: '',
  workAreaId: 'all',
  permitType: 'all',
  workDate: todayInput(),
})
